import React from 'react';

type Props = {
  msg: any;
};

export default function ErrorMessage({ msg }: Props) {
  return <p className='text-sm text-red-600'>{msg}</p>;
}
